import { HighIirFilter, LowIirFilter } from "./filters";

export class FiltersFactory {
  constructor() {}

  static create(filterInfo) {
    switch (filterInfo.type) {
      case "HIGH":
        return new HighIirFilter(new Float32Array(filterInfo.b), new Float32Array(filterInfo.a));
      case "LOW":
        return new LowIirFilter(new Float32Array(filterInfo.b), new Float32Array(filterInfo.a));
    }
    return undefined;
  }
}
